"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("@lcifr/sx").sx("div")((({above:e,below:o},{up:s,down:d})=>e?{[s(e)]:{display:"none"}}:o?{[d(o)]:{display:"none"}}:void 0));exports.Hidden=e;
